import React from 'react';
import './bar-projects.css';
// import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
// import { hideNavbar } from '../header/header';


export function BarProjects (props) {
  // const nav = useNavigate();
  
  return (
    <section className="bar-projects">
      <div className="container">
        <h1>{props.texts.title}</h1>
        <div className="content">
          {props.texts.projects.map((project, index) => (
              <Link key={index} to={`/about#projects?=${index}`}>
                <img key={index}
                     src={project.logo.src}
                     alt={project.logo.alt}
                     width="256"
                     height="256"
                    //  onClick={() => {nav("/about/#projects");hideNavbar();}}
                />
              </Link>
          ))}
        </div>
      </div>
    </section>
  );
}


export default BarProjects;